import axiosInstance from '../../utils/axios-instance';
import {actionCreator, createRequestTypes, getErrorMessage} from '../../utils/helpers';

export const SET_FROM_SIGNUP_TO_SURVEY = createRequestTypes('SET_FROM_SIGNUP_TO_SURVEY');
export const SET_FROM_SURVEY_TO_SIGNUP = createRequestTypes('SET_FROM_SURVEY_TO_SIGNUP');
export const CHANGE_ACCOUNT_STATUS = createRequestTypes('CHANGE_ACCOUNT_STATUS');
export const CANCEL_ACCOUNT_STATUS_TRANSITION = createRequestTypes('CANCEL_ACCOUNT_STATUS_TRANSITION');

export const convertFromSignupToSurvey = (id, updateServiceOrders) => async (dispatch) => {
    dispatch(actionCreator.request(SET_FROM_SIGNUP_TO_SURVEY));

    try {
        const response = await axiosInstance.get(`/account/${id}/signuptosurvey`, {params: {updateServiceOrders}});
        dispatch(actionCreator.success(SET_FROM_SIGNUP_TO_SURVEY))
        return response.data;
    } catch(err) {
        let mockError = {
            message: err.response.data.error.message
        };
        dispatch(actionCreator.failure(SET_FROM_SIGNUP_TO_SURVEY, mockError))
    }
}

export const convertFromSurveyToSignUp = (id, updateServiceOrders) => async (dispatch) => {
	dispatch(actionCreator.request(SET_FROM_SURVEY_TO_SIGNUP));

	try {
		const response = await axiosInstance.get(`/account/${id}/surveytosignup`, {params:{updateServiceOrders}});
        dispatch(actionCreator.success(SET_FROM_SURVEY_TO_SIGNUP));
        return response.data
	} catch(err) {
		let mockError = {
            message: err.response.data.error.message
		};
		dispatch(actionCreator.failure(SET_FROM_SURVEY_TO_SIGNUP, mockError));
		return err.response.data;
	}
}

export const changeAccountStatus = (accountId, toStatus, applyOnType, applyOnDate, provisionImmediately, reasoncodeId) => async (dispatch) => {
    dispatch(actionCreator.request(CHANGE_ACCOUNT_STATUS));

    let data = {
        toStatus: toStatus,
        accountStatusApplyOnEnum: applyOnType,
        applyOnDate: applyOnDate,
        provisionImmediately: provisionImmediately,
        reasoncodeId: reasoncodeId
    }

    if (data.accountStatusApplyOnEnum == "") {
        data.accountStatusApplyOnEnum = null
    }

    try {
        const response = await axiosInstance.post(`/account/${accountId}/status-transition-with-apply-on`, data);
        dispatch(actionCreator.success(CHANGE_ACCOUNT_STATUS));

        return response;
    } catch(err) {
        dispatch(actionCreator.failure(CHANGE_ACCOUNT_STATUS, getErrorMessage(err)));

        return  err;
    }
}

export const cancelAccountStatusTransition = (accountId, processInstanceId) => async (dispatch) => {
    dispatch(actionCreator.request(CANCEL_ACCOUNT_STATUS_TRANSITION));

    try {
        const response = await axiosInstance.post(`/account/${accountId}/transition/cancel`, processInstanceId);
        dispatch(actionCreator.success(CANCEL_ACCOUNT_STATUS_TRANSITION));
        return response;
    } catch(err) {
        dispatch(actionCreator.failure(CANCEL_ACCOUNT_STATUS_TRANSITION, getErrorMessage(err)));
        return  err;
    }
}